
/////////////////////////////Without Deliverables and Updated on Earthlink/////////////////////

// import ExcelJS from 'exceljs';
// import { saveAs } from 'file-saver';
// import dayjs from "dayjs";
// import axios from 'axios';
// import { message } from 'antd';

// import {
//   API_HEADER,
//   get_time_sheetData,
// } from "../config";

// const dateTimeFormat = "DD/MM/YYYY HH:mm";

// export const exportTimesheet = async (filters,startDate,endDate) => {
//   try {
//     message.loading('Preparing Excel export...', 0);

//     const payload = {
//       ...filters,
//       start_date: startDate ? startDate.format("YYYY-MM-DD") : null,
//         end_date: endDate ? endDate.format("YYYY-MM-DD") : null,
//       export: "export",
//     };

//     const response = await axios.post(
//       `${get_time_sheetData}`,
//       payload,
//       API_HEADER
//     );

//     const allData = response.data.timesheets;
//     console.log("Exporting timesheet data:", allData);

//     const workbook = new ExcelJS.Workbook();
//     const worksheet = workbook.addWorksheet('Timesheet Report');

//     // Add headers
//     const headers = [
//       'S.No',
//       'Project Name',
//       'Earthood ID',
//       'Task Name',
//       'Role',
//       'Start Date',
//       'End Date',
//       'Total Time',
//       'Status',
//       'Remarks'
//     ];

//     //////////////for heading Timesheet Report (02/06/2025) 
    
//     const currentDate = dayjs().format('DD/MM/YYYY');
//     const headingRow = worksheet.addRow([`Timesheet Report (${currentDate})`]);
    
//     // Merge cells for the heading (merge all columns in the first row)
//     worksheet.mergeCells(`A1:${String.fromCharCode(64 + headers.length)}1`);
    
//     // Style the heading
//     headingRow.getCell(1).font = { bold: true, size: 14 };
//     headingRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
//     headingRow.height = 25; // Make the heading row taller

//     // Add empty row for spacing
//     // worksheet.addRow([]);

//     //////////////////////////////
    
//     const headerRow = worksheet.addRow(headers);

//     // Style headers
//     headerRow.eachCell(cell => {
//       cell.fill = {
//         type: 'pattern',
//         pattern: 'solid',
//         fgColor: { argb: 'FFD700' } // Gold color
//       };
//       cell.font = { bold: true, color: { argb: 'FF000000' } };
//       cell.border = {
//         top: { style: 'thin', color: { argb: 'FF000000' } },
//         left: { style: 'thin', color: { argb: 'FF000000' } },
//         bottom: { style: 'thin', color: { argb: 'FF000000' } },
//         right: { style: 'thin', color: { argb: 'FF000000' } }
//       };
//       cell.alignment = { vertical: 'middle', horizontal: 'center' };
//     });

//     // Add data rows
//     allData.forEach((row, rowIndex) => {
//       const dataRow = worksheet.addRow([
//         rowIndex + 1,
//         row.project_name || 'N/A',
//         row.earthood_id || 'N/A',
//         row.task_name || 'N/A',
//         row.role_name || 'N/A',
//         row.start_date ? dayjs(row.start_date).format(dateTimeFormat) : 'N/A',
//         row.end_date ? dayjs(row.end_date).format(dateTimeFormat) : 'N/A',
//         row.total_consumed_time || 'N/A',
//         row.status || 'N/A',
//         row.remarks || 'N/A'
//       ]);

//       // Format date columns
//       if (row.start_date) {
//         dataRow.getCell(6).numFmt = 'dd/mm/yyyy hh:mm';
//       }
//       if (row.end_date) {
//         dataRow.getCell(7).numFmt = 'dd/mm/yyyy hh:mm';
//       }

//       // Add borders to data cells
//       dataRow.eachCell(cell => {
//         cell.border = {
//           top: { style: 'thin', color: { argb: 'FF000000' } },
//           left: { style: 'thin', color: { argb: 'FF000000' } },
//           bottom: { style: 'thin', color: { argb: 'FF000000' } },
//           right: { style: 'thin', color: { argb: 'FF000000' } }
//         };
//       });
//     });

//     // Auto-fit columns
//     worksheet.columns.forEach(column => {
//       let maxLength = 0;
//       column.eachCell({ includeEmpty: true }, cell => {
//         let columnLength = cell.value ? cell.value.toString().length : 0;
//         if (columnLength > maxLength) {
//           maxLength = columnLength;
//         }
//       });
//       column.width = Math.min(Math.max(maxLength + 2, 10), 30);
//     });

//     // Freeze header row
//     worksheet.views = [
//       { state: 'frozen', ySplit: 1 }
//     ];

//     // Generate and download
//     const buffer = await workbook.xlsx.writeBuffer();
//     saveAs(
//       new Blob([buffer], { type: 'application/octet-stream' }),
//       `Timesheet-Report-${dayjs().format('YYYY-MM-DD')}.xlsx`
//     );
    
//     message.destroy();
//     message.success('Excel exported successfully!');
//   } catch (error) {
//     message.destroy();
//     message.error('Failed to export Excel: ' + error.message);
//     console.error('Export error:', error);
//   }
// };



/////////////////////with all fields wrapped in a single row/////////////////////

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import dayjs from "dayjs";
import axios from 'axios';
import { message } from 'antd';

import {
  API_HEADER,
  // get_time_sheetData,
} from "../config";

const dateTimeFormat = "DD/MM/YYYY HH:mm";

export const exportTimesheet = async (filters, startDate, endDate, api) => {
  try {
    message.loading('Preparing Excel export...', 0);

    const payload = {
      ...filters,
      start_date: startDate ? startDate.format("YYYY-MM-DD") : null,
      end_date: endDate ? endDate.format("YYYY-MM-DD") : null,
      export: "export",
    };

    const response = await axios.post(
      `${api}`,
      payload,
      API_HEADER
    );

    const allData = response.data.timesheets;
    console.log("Exporting timesheet data:", allData);

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Timesheet Report');

    // Add headers
    const headers = [
      'S.No',
      'Project Name',
      'Earthood ID',
      'Task Name',
      'Role',
      'Start Date',
      'End Date',
      'Total Time',
      'Status',
      "Deliverables",
      "Updated on Earthlink",
      'Remarks'
    ];

    // Add heading "Timesheet Report (current date)"
    const currentDate = dayjs().format('DD/MM/YYYY');
    const headingRow = worksheet.addRow([`Timesheet Report (${currentDate})`]);
    
    // Merge cells for the heading
    worksheet.mergeCells(`A1:${String.fromCharCode(64 + headers.length)}1`);
    
    // Style the heading
    headingRow.getCell(1).font = { bold: true, size: 14 };
    headingRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
    headingRow.height = 25;

    // Add empty row for spacing
    worksheet.addRow([]);

    // Add column headers
    const headerRow = worksheet.addRow(headers);

    // Style headers
    headerRow.eachCell(cell => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD700' } // Gold color
      };
      cell.font = { bold: true, color: { argb: 'FF000000' } };
      cell.border = {
        top: { style: 'thin', color: { argb: 'FF000000' } },
        left: { style: 'thin', color: { argb: 'FF000000' } },
        bottom: { style: 'thin', color: { argb: 'FF000000' } },
        right: { style: 'thin', color: { argb: 'FF000000' } }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });

    // Add data rows
    allData.forEach((row, rowIndex) => {
      // Process additional_status to show completed deliverables
      const deliverables = row.additional_status 
        ? row.additional_status
            .filter(item => item.value === 1)
            .map(item => item.label)
            .join(", ")
        : 'N/A';
      
      // Process is_document_uploaded to show Yes/No
      const documentUploaded = row.is_document_uploaded === 1 ? 'Yes' : 'No';

      const dataRow = worksheet.addRow([
        rowIndex + 1,
        row.project_name || 'N/A',
        row.earthood_id || 'N/A',
        row.task_name || 'N/A',
        row.role_name || 'N/A',
        row.start_date ? dayjs(row.start_date).format(dateTimeFormat) : 'N/A',
        row.end_date ? dayjs(row.end_date).format(dateTimeFormat) : 'N/A',
        row.total_consumed_time || 'N/A',
        row.status || 'N/A',
        deliverables,
        documentUploaded,
        row.remarks || 'N/A'
      ]);

      // Format date columns
      if (row.start_date) {
        dataRow.getCell(6).numFmt = 'dd/mm/yyyy hh:mm';
      }
      if (row.end_date) {
        dataRow.getCell(7).numFmt = 'dd/mm/yyyy hh:mm';
      }

      // Add borders to data cells
      dataRow.eachCell(cell => {
        cell.border = {
          top: { style: 'thin', color: { argb: 'FF000000' } },
          left: { style: 'thin', color: { argb: 'FF000000' } },
          bottom: { style: 'thin', color: { argb: 'FF000000' } },
          right: { style: 'thin', color: { argb: 'FF000000' } }
        };
      });
    });

    // Auto-fit columns
    worksheet.columns.forEach(column => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, cell => {
        let columnLength = cell.value ? cell.value.toString().length : 0;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = Math.min(Math.max(maxLength + 2, 10), 30);
    });

    // Freeze header row
    worksheet.views = [
      { state: 'frozen', ySplit: 2 } // Split after the header row (row 2)
    ];

    // Generate and download
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer], { type: 'application/octet-stream' }),
      `Timesheet-Report-${dayjs().format('YYYY-MM-DD')}.xlsx`
    );
    
    message.destroy();
    message.success('Excel exported successfully!');
  } catch (error) {
    message.destroy();
    message.error('Failed to export Excel: ' + error.message);
    console.error('Export error:', error);
  }
};




////////////////////////////////All fields are wrapped ////////////////////////////////////

// import ExcelJS from 'exceljs';
// import { saveAs } from 'file-saver';
// import dayjs from "dayjs";
// import axios from 'axios';
// import { message } from 'antd';

// import {
//   API_HEADER,
//   get_time_sheetData,
// } from "../config";

// const dateTimeFormat = "DD/MM/YYYY HH:mm";

// export const exportTimesheet = async (filters, startDate, endDate) => {
//   try {
//     message.loading('Preparing Excel export...', 0);

//     const payload = {
//       ...filters,
//       start_date: startDate ? startDate.format("YYYY-MM-DD") : null,
//       end_date: endDate ? endDate.format("YYYY-MM-DD") : null,
//       export: "export",
//     };

//     const response = await axios.post(
//       `${get_time_sheetData}`,
//       payload,
//       API_HEADER
//     );

//     const allData = response.data.timesheets;
//     console.log("Exporting timesheet data:", allData);

//     const workbook = new ExcelJS.Workbook();
//     const worksheet = workbook.addWorksheet('Timesheet Report');

//     const headers = [
//       'S.No',
//       'Project Name',
//       'Earthood ID',
//       'Task Name',
//       'Role',
//       'Start Date',
//       'End Date',
//       'Total Time',
//       'Status',
//       "Deliverables",
//       "Updated on Earthlink",
//       'Remarks'
//     ];

//     const currentDate = dayjs().format('DD/MM/YYYY');
//     const headingRow = worksheet.addRow([`Timesheet Report (${currentDate})`]);
//     worksheet.mergeCells(`A1:${String.fromCharCode(64 + headers.length)}1`);
//     headingRow.getCell(1).font = { bold: true, size: 14 };
//     headingRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'center' };
//     headingRow.height = 25;

//     worksheet.addRow([]);

//     const headerRow = worksheet.addRow(headers);
//     headerRow.eachCell(cell => {
//       cell.fill = {
//         type: 'pattern',
//         pattern: 'solid',
//         fgColor: { argb: 'FFD700' }
//       };
//       cell.font = { bold: true, color: { argb: 'FF000000' } };
//       cell.border = {
//         top: { style: 'thin', color: { argb: 'FF000000' } },
//         left: { style: 'thin', color: { argb: 'FF000000' } },
//         bottom: { style: 'thin', color: { argb: 'FF000000' } },
//         right: { style: 'thin', color: { argb: 'FF000000' } }
//       };
//       cell.alignment = {
//         vertical: 'middle',
//         horizontal: 'center',
//         wrapText: true   // ✅ Wrap header text
//       };
//     });

//     allData.forEach((row, rowIndex) => {
//       const deliverables = row.additional_status 
//         ? row.additional_status
//             .filter(item => item.value === 1)
//             .map(item => item.label)
//             .join(", ")
//         : 'N/A';

//       const documentUploaded = row.is_document_uploaded === 1 ? 'Yes' : 'No';

//       const dataRow = worksheet.addRow([
//         rowIndex + 1,
//         row.project_name || 'N/A',
//         row.earthood_id || 'N/A',
//         row.task_name || 'N/A',
//         row.role_name || 'N/A',
//         row.start_date ? dayjs(row.start_date).format(dateTimeFormat) : 'N/A',
//         row.end_date ? dayjs(row.end_date).format(dateTimeFormat) : 'N/A',
//         row.total_consumed_time || 'N/A',
//         row.status || 'N/A',
//         deliverables,
//         documentUploaded,
//         row.remarks || 'N/A'
//       ]);

//       if (row.start_date) {
//         dataRow.getCell(6).numFmt = 'dd/mm/yyyy hh:mm';
//       }
//       if (row.end_date) {
//         dataRow.getCell(7).numFmt = 'dd/mm/yyyy hh:mm';
//       }

//       dataRow.eachCell(cell => {
//         cell.border = {
//           top: { style: 'thin', color: { argb: 'FF000000' } },
//           left: { style: 'thin', color: { argb: 'FF000000' } },
//           bottom: { style: 'thin', color: { argb: 'FF000000' } },
//           right: { style: 'thin', color: { argb: 'FF000000' } }
//         };
//         cell.alignment = {
//           vertical: 'top',
//           horizontal: 'left',
//           wrapText: true   // ✅ Wrap data cell text
//         };
//       });
//     });

//     worksheet.columns.forEach(column => {
//       let maxLength = 0;
//       column.eachCell({ includeEmpty: true }, cell => {
//         let columnLength = cell.value ? cell.value.toString().length : 0;
//         if (columnLength > maxLength) {
//           maxLength = columnLength;
//         }
//       });
//       column.width = Math.min(Math.max(maxLength + 2, 10), 30);
//     });

//     worksheet.views = [
//       { state: 'frozen', ySplit: 2 }
//     ];

//     const buffer = await workbook.xlsx.writeBuffer();
//     saveAs(
//       new Blob([buffer], { type: 'application/octet-stream' }),
//       `Timesheet-Report-${dayjs().format('YYYY-MM-DD')}.xlsx`
//     );

//     message.destroy();
//     message.success('Excel exported successfully!');
//   } catch (error) {
//     message.destroy();
//     message.error('Failed to export Excel: ' + error.message);
//     console.error('Export error:', error);
//   }
// };
